module.exports = __webpack_public_path__ + "static/assets/4487771862c62920a3a6038c3ff515e3.gif";